/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as AdminDefs from './defs.defs.js'
import * as RepoStrongRef from '../repo/strongRef.defs.js'

const $nsid = 'com.atproto.admin.updateSubjectStatus'

export { $nsid }

/** Update the service-specific admin status of a subject (account, record, or blob). */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    subject: l.typedUnion(
      [
        l.typedRef<AdminDefs.RepoRef>((() => AdminDefs.repoRef) as any),
        l.typedRef<RepoStrongRef.Main>((() => RepoStrongRef.main) as any),
        l.typedRef<AdminDefs.RepoBlobRef>((() => AdminDefs.repoBlobRef) as any),
      ],
      false,
    ),
    takedown: l.optional(
      l.ref<AdminDefs.StatusAttr>((() => AdminDefs.statusAttr) as any),
    ),
    deactivated: l.optional(
      l.ref<AdminDefs.StatusAttr>((() => AdminDefs.statusAttr) as any),
    ),
  }),
  l.jsonPayload({
    subject: l.typedUnion(
      [
        l.typedRef<AdminDefs.RepoRef>((() => AdminDefs.repoRef) as any),
        l.typedRef<RepoStrongRef.Main>((() => RepoStrongRef.main) as any),
        l.typedRef<AdminDefs.RepoBlobRef>((() => AdminDefs.repoBlobRef) as any),
      ],
      false,
    ),
    takedown: l.optional(
      l.ref<AdminDefs.StatusAttr>((() => AdminDefs.statusAttr) as any),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
